import React from 'react';

const Disclaimer = () => (
  <p className="p2 paddingTop-small1">
    *Members are billed on a monthly basis, but the membership is still a year-long commitment.
  </p>
);

export default Disclaimer;
